module.exports = __webpack_public_path__ + "media/images/varta/VARTA_Promotive_Silver_470x520-3a5cbc18b36ed9e509587de6c0d249dd.png";